import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';

import check from 'src/static/vectors/check.svg';
import './PrivacyCheckbox.css';

const PrivacyCheckbox = ({ required = true, link = true }: { required?: boolean; link?: boolean }) => {
	const privacyLink = (
		<Link to="/legal/privacy-policy">
			<FormattedMessage id="privacy-link" />
		</Link>
	);
	return (
		<>
			<label id="privacy-checkbox">
				<input required={required} type="checkbox" name="subject" />
				<span>
					<img className="symbol" src={check} alt="Trueflag symbol" />
				</span>
				<span className="form-privacy">
					<FormattedMessage id="form.privacy-1" />
				</span>
			</label>
			{link && (
				<span className="form-privacy">
					<FormattedMessage id="form.privacy-2" values={{ privacyLink }} />
				</span>
			)}
		</>
	);
};

export default PrivacyCheckbox;
